import { ReactNode } from 'react';

import Text from '@ui/text/text/text';
import Icon from '@ui/icons/icon';
import { ICONS } from '@ui/icons/types';

type TLanguageSelectorMultiValueProps = {
  isBase: boolean;
  children: ReactNode;
  isFocusedWithin?: boolean;
  selectedSize: number;
};

const LanguageSelectorMultiValue = ({
  isBase,
  children,
  isFocusedWithin,
  selectedSize,
}: TLanguageSelectorMultiValueProps) => {
  return (
    <Text
      clamp={1}
      className="S3 uppercase flex ai-center"
      whiteSpace="normal"
      minWidth={isFocusedWithin ? 'max-content' : undefined}
    >
      <Text
        whiteSpace={selectedSize === 1 ? 'nowrap' : 'normal'}
        tag="span"
        width="100%"
        minWidth={isFocusedWithin ? 'fit-content' : undefined}
      >
        {children}
      </Text>
      {isBase ? (
        <Text tag="span" className="margin-l-6">
          <Icon name={ICONS.STAR} size={10} />
        </Text>
      ) : (
        ''
      )}
    </Text>
  );
};

export default LanguageSelectorMultiValue;
